'use client';

import { type AnyVideo, VideoType, formatCount } from '../../functions';
import { useCommentsCount } from '../hooks/useCommentsCount';
import { ActionButton } from './ActionButton';

type CommentActionProps = {
  video: AnyVideo;
  onOpenComments?: () => void;
  className?: string;
};

export function CommentAction({
  video,
  onOpenComments,
  className,
}: CommentActionProps) {
  const { commentsCount, loading } = useCommentsCount(video.id, video);

  if (video.type !== VideoType.Clips) return null;

  return (
    <ActionButton
      onClick={onOpenComments}
      disabled={loading}
      className={className}
      label={commentsCount > 0 ? formatCount(commentsCount) : undefined}
    >
      {loading ? (
        <div className="border-raise/30 h-5 w-5 animate-spin rounded-full border-2 border-t-white" />
      ) : (
        <svg fill="none" viewBox="0 0 256 256" width={24} height={24}>
          <path
            d="M168,112a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,112Zm-8,24H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm72-8A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-16,0A88,88,0,1,0,51.81,172.06a8,8,0,0,1,.66,6.54L40,216,77.4,203.53a7.85,7.85,0,0,1,2.53-.42,8,8,0,0,1,4,1.08A88,88,0,0,0,216,128Z"
            fill="#FFFFFF"
          />
        </svg>
      )}
    </ActionButton>
  );
}
